import { render, staticRenderFns } from "./OrderStory.vue?vue&type=template&id=501585ff&scoped=true"
import script from "./OrderStory.vue?vue&type=script&lang=js"
export * from "./OrderStory.vue?vue&type=script&lang=js"
import style0 from "./OrderStory.vue?vue&type=style&index=0&id=501585ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501585ff",
  null
  
)

export default component.exports